import UserCenter from './UserCenter';
import AddressList from './AddressList';
import AddressEdit from './AddressEdit';
import TravelerList from './TravelerList';
import TravelerEdit from './TravelerEdit';
import UserRecommend from './UserRecommend';
import Feedback from './Feedback';
import UserInfo from './UserInfo';
import CollectList from './CollectList';

const ACTION = {
  ...UserCenter.ACTION,
  ...AddressList.ACTION,
  ...AddressEdit.ACTION,
  ...TravelerList.ACTION,
  ...TravelerEdit.ACTION,
  ...UserRecommend.ACTION,
  ...Feedback.ACTION,
  ...UserInfo.ACTION,
  ...CollectList.ACTION,
};

const ACTION_TYPES = {
  ...UserCenter.ACTION_TYPES,
  ...AddressList.ACTION_TYPES,
  ...AddressEdit.ACTION_TYPES,
  ...TravelerList.ACTION_TYPES,
  ...TravelerEdit.ACTION_TYPES,
  ...UserRecommend.ACTION_TYPES,
  ...Feedback.ACTION_TYPES,
  ...UserInfo.ACTION_TYPES,
  ...CollectList.ACTION_TYPES,
};

const User = {
  ACTION,
  ACTION_TYPES
}

export default User;